// =============================================================================
// web/shims/react-native-image-picker.js — WEB shim.
//
// react-native-image-picker opens the native camera/photo library. On the web
// target that native surface does not exist. Rather than crash the bundle, this
// shim resolves as a graceful "cancelled" pick (didCancel: true) so any caller
// that awaits launchImageLibrary/launchCamera gets a clean no-op instead of media.
// Web media upload can be added later via <input type="file">; for now web is a
// read-first experience and pickers no-op. Native iOS resolves the real module.
// =============================================================================
const CANCELLED = { didCancel: true, assets: undefined, errorCode: undefined };

export async function launchImageLibrary() {
  return CANCELLED;
}

export async function launchCamera() {
  return CANCELLED;
}

export default {
  launchImageLibrary,
  launchCamera,
};
